import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const { translations } = useLanguage();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="header">
            <button onClick={handleBack} className="back-button">&#8592;</button>
            <h1>{translations.recover_account}</h1>
        </div>
        <form className="general-form">
          <div className="form-group">
            <input
              type="email"
              placeholder={translations.email}
              className="general-input"
            />
          </div>
          <button type="submit" className="general-button">{translations.send_recovery_mail}</button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
